import { gql } from '@apollo/client'

export const UPDATE_PROCESSING_MUTATION = gql`
  mutation updateProcessing($id: ID!, $attributes: ProcessingInput!) {
    updateProcessing(id: $id, attributes: $attributes) {
      id
      acceptedAt
      actualProcessingTypeId
      additionalCost
      assignedProcessingTypeId
      intendedProcessingTypeId
      paymentRequestCost
      paymentRequestCostSource
      processingState
      agent {
        id
        name
      }
      alternativeProcess
    }
  }
`
